import React from "react";
import AugsburgerAktienbankIcon from "@images/banks-full/ausburger.svg?react";
import DABIcon from "@images/banks-full/dab-bnp.svg?react";
import ComdirectIcon from "@images/banks-full/comdirect.svg?react";
import DWSIcon from "@images/banks-full/dws.svg?react";
import FnzIcon from "@images/banks-full/fnz.svg?react";
import FFBIcon from "@images/banks-full/ffb.svg?react";
import FondsdepotBankIcon from "@images/banks-full/fondsdepot.svg?react";
import MetzlerIcon from "@images/banks-full/metzler.svg?react";
import MorgenFundIcon from "@images/banks-full/morgenfund.svg?react";

export const bicToIcon = (bic: string) => {
  switch (bic) {
    case "COBADEHDXXX": // comdirect bank AG
      return <ComdirectIcon />;
    case "DABBDEMMXXX": // DAB
      return <DABIcon />;
    case "AUGBDE77XXX": // Augsburger Aktienbank
      return <AugsburgerAktienbankIcon />;
    case "DEUTDEFFXXX": // DWS
      return <DWSIcon />;
    case "DEUTLU2DXXX": // MorgenFund
      return <MorgenFundIcon />;
    case "COBADEMXXXX": // ebase
      return <FnzIcon />;
    case "FFBKDEFFTHK": // FIL Fondsbank (FFB)
      return <FFBIcon />;
    case "FODBDE77XXX": // Fondsdepot Bank
      return <FondsdepotBankIcon />;
    case "METZDEFFXXX": // Metzler
      return <MetzlerIcon />;
    default:
      throw new Error("Given bic is invalid or has no icon mapping defined");
  }
};

export const bicToUrl = (bic: string) => {
  const urlBase = `${import.meta.env.VITE_APP_ROOT_URL};`;
  switch (bic) {
    case "COBADEHDXXX": // comdirect bank AG
      return `${urlBase}/comdirect`;
    case "DABBDEMMXXX": // DAB
      return `${urlBase}/dab`;
    case "AUGBDE77XXX": // Augsburger Aktienbank
      return `${urlBase}/augsburger-aktienbank`;
    case "DEUTDEFFXXX": // DWS
      return "";
    case "DEUTLU2DXXX": // MorgenFund
      return "";
    case "COBADEMXXXX": // ebase
      return `${urlBase}/ebase`;
    case "FFBKDEFFTHK": // FIL Fondsbank (FFB)
      return `${urlBase}/fil-fondsbank`;
    case "FODBDE77XXX": // Fondsdepot Bank
      return `${urlBase}/fondsdepotbank`;
    case "METZDEFFXXX": // Metzler
      return `${urlBase}/metzler`;
    default:
      throw new Error("Given bic is invalid or has no URL defined");
  }
};

export const bicToName = (bic: Bic, shortNames = false) => {
  switch (bic) {
    case "COBADEHDXXX": // comdirect bank AG
      return "comdirect";
    case "DABBDEMMXXX": // DAB
      return shortNames ? "DAB" : "DAB BNP Paribas";
    case "AUGBDE77XXX": // Augsburger Aktienbank
      return shortNames ? "AAB" : "Augsburger Aktienbank";
    case "DEUTDEFFXXX": // DWS
      return "DWS Vorsorge";
    case "DEUTLU2DXXX": // MorgenFund
      return "MorgenFund";
    case "COBADEMXXXX": // ebase
      return "ebase";
    case "FFBKDEFFTHK": // FIL Fondsbank (FFB)
      return shortNames ? "FFB" : "FFB (FIL Fondsbank)";
    case "FODBDE77XXX": // Fondsdepot Bank
      return "Fondsdepotbank";
    case "METZDEFFXXX": // Metzler
      return "Metzler / MFX";
    default:
      throw new Error("Given bic is invalid or has no name mapping defined");
  }
};

export const ORDERED_BICS: Bic[] = [
  "AUGBDE77XXX",
  "COBADEHDXXX",
  "COBADEMXXXX",
  "DABBDEMMXXX",
  "DEUTDEFFXXX",
  "DEUTLU2DXXX",
  "FFBKDEFFTHK",
  "FODBDE77XXX",
  "METZDEFFXXX",
];
